import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_2 = {
  class: "modal fade",
  id: "imageUpload",
  tabindex: "-1",
  "aria-labelledby": "detailviewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "imageUpload"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "gallery-wrap custom-scroll" }
const _hoisted_10 = { class: "row mx-n2 mt-2" }
const _hoisted_11 = {
  key: 0,
  class: "shadowed-card bg-white mb-3"
}
const _hoisted_12 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_14 = { class: "imaged-col" }
const _hoisted_15 = { class: "small-img-wrap" }
const _hoisted_16 = {
  key: 0,
  href: "javascript:void(0)",
  title: "click to rename"
}
const _hoisted_17 = {
  key: 0,
  class: "edit-control"
}
const _hoisted_18 = {
  key: 1,
  class: "save-icon",
  href: "javascript:void(0)"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_20 = { class: "size" }
const _hoisted_21 = {
  key: 1,
  class: "file-actions bg-light p-2 shadow"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_23 = { class: "my-1 mb-3" }
const _hoisted_24 = { class: "row mx-n2" }
const _hoisted_25 = { class: "image-box" }
const _hoisted_26 = { class: "image-wrapp" }
const _hoisted_27 = { class: "same-ht-img" }
const _hoisted_28 = { class: "file-name bg-light p-2" }
const _hoisted_29 = { class: "font-weight-bold" }
const _hoisted_30 = {
  href: "javascript:void(0)",
  title: "click to rename"
}
const _hoisted_31 = {
  key: 1,
  class: "file-actions bg-light p-2 shadow"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = { class: "modal-wrap default-modal" }
const _hoisted_36 = {
  class: "modal fade",
  id: "deleteImage",
  tabindex: "-1",
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_37 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-header" }
const _hoisted_40 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "hidePojectLabel"
}, "Delete Project Image", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-danger mb-0",
    role: "alert"
  }, " Are you sure you want to delete? ")
], -1)
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = { class: "modal-wrap default-modal" }
const _hoisted_45 = {
  class: "modal fade",
  id: "renameFileModal",
  tabindex: "-1",
  "aria-labelledby": "renameModalLabel",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_47 = { class: "modal-content" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "renameModalLabel"
}, "Rename", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h5", _hoisted_6, "Upload Image " + _toDisplayString(_ctx.project.name), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDetailModal && _ctx.closeDetailModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_7
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                (_ctx.state.data.project.status_id!== 2)
                  ? (_openBlock(), _createBlock(_component_DragAndDropZone, {
                      key: 0,
                      onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
                      onDropFiles: _ctx.dropFiles
                    }, null, 8, ["onDrop", "onDropFiles"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_10, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.imagesToUpload, (image, imageIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-3 px-2",
                      key: imageIndex
                    }, [
                      (image.extension === 'jpg' ||
                  image.extension === 'png' ||
                  image.extension === 'jpeg' ||
                  image.extension === 'gif'
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_11, [
                            (image.isuploded && image.isvalidToUpload)
                              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                  _hoisted_13
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_14, [
                              _createVNode("div", _hoisted_15, [
                                _createVNode("img", {
                                  src: image.base64,
                                  alt: "",
                                  height: "200"
                                }, null, 8, ["src"])
                              ]),
                              _createVNode("h5", null, [
                                (!image.isEdit)
                                  ? (_openBlock(), _createBlock("a", _hoisted_16, _toDisplayString(image.fileName), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.state.data.project.status_id!== 2)
                                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                    (image.isEdit)
                                      ? _withDirectives((_openBlock(), _createBlock("input", {
                                          key: 0,
                                          "onUpdate:modelValue": ($event: any) => (image.fileName = $event),
                                          id: "user-name",
                                          type: "text",
                                          class: "form-control bg-light"
                                        }, null, 8, ["onUpdate:modelValue"])), [
                                          [_vModelText, image.fileName]
                                        ])
                                      : _createCommentVNode("", true),
                                    (image.isEdit)
                                      ? (_openBlock(), _createBlock("a", _hoisted_18, [
                                          _hoisted_19
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("p", _hoisted_20, _toDisplayString(image.size), 1)
                            ]),
                            (_ctx.state.data.project.status_id!== 2)
                              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                  _createVNode("a", {
                                    class: "dropdown-item p-0 text-danger",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.deleteImage(imageIndex))
                                  }, [
                                    _hoisted_22
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_23, [
                  (_ctx.state.data.imagesToUpload.length)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn default-btn",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadAttachments && _ctx.uploadAttachments(...args))),
                        disabled: _ctx.state.ui.isPostLoading.uploadImage
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.uploadImage ? 'Uploading...' :'Upload'), 9, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_24, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.imageList, (image, imageIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-2 px-2",
                      key: imageIndex
                    }, [
                      (image.file_type === 'jpg' ||
                  image.file_type === 'png' ||
                  image.file_type === 'jpeg' ||
                  image.file_type === 'gif'
                  )
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "shadowed-card bg-white mb-3",
                            onClick: ($event: any) => (_ctx.clickImage(_ctx.state.data.imageList, imageIndex))
                          }, [
                            _createVNode("div", _hoisted_25, [
                              _createVNode("div", _hoisted_26, [
                                _createVNode("div", _hoisted_27, [
                                  _createVNode("img", {
                                    src: image.file_link,
                                    alt: "",
                                    height: "200",
                                    class: "rounded-top"
                                  }, null, 8, ["src"])
                                ])
                              ]),
                              _createVNode("div", _hoisted_28, [
                                _createVNode("p", _hoisted_29, [
                                  _createVNode("a", _hoisted_30, _toDisplayString(image.file_name), 1)
                                ])
                              ])
                            ])
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((_ctx.project.project_role.code == 'owner' || _ctx.project.project_role.code == 'co-owner' || _ctx.state.data.loginUserId == image.user_id) && _ctx.state.data.project.status_id!== 2)
                        ? (_openBlock(), _createBlock("div", _hoisted_31, [
                            _createVNode("a", {
                              class: "dropdown-item p-0 text-success mb-1",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.showRenameImage(image))
                            }, [
                              _hoisted_32
                            ], 8, ["onClick"]),
                            _createVNode("a", {
                              class: "dropdown-item p-0 text-danger",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.deleteProjectImage(image))
                            }, [
                              _hoisted_33
                            ], 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDetailModal && _ctx.closeDetailModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ]),
      _createVNode(_component_vue_easy_lightbox, {
        visible: _ctx.visibleRef,
        imgs: _ctx.imgsRef,
        index: _ctx.indexRef,
        onOnPrev: _ctx.handlePrev,
        onOnNext: _ctx.handleNext,
        onHide: _ctx.handleHide
      }, null, 8, ["visible", "imgs", "index", "onOnPrev", "onOnNext", "onHide"])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_35, [
      _createVNode("div", _hoisted_36, [
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteProjectImageClose && _ctx.deleteProjectImageClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_41
              ])
            ]),
            _hoisted_42,
            _createVNode("div", _hoisted_43, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.imageDelete && _ctx.imageDelete(...args))),
                disabled: _ctx.state.ui.isPostLoading.deleteProjectImage
              }, _toDisplayString(_ctx.state.ui.isPostLoading.deleteProjectImage ? "loading..." : "Yes"), 9, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteProjectImageClose && _ctx.deleteProjectImageClose(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_44, [
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _hoisted_49,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeRenameImage && _ctx.closeRenameImage(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_50
              ])
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "rename",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.selectImageName = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.selectImageName]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_53, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.editName && _ctx.editName(...args)))
              }, " Save Changes "),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeRenameImage && _ctx.closeRenameImage(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}